<script>
import {notificationMethods, authMethods} from "@/state/helpers";

import { required } from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Şifre Değiştir",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast
  },
  data() {
    return {
      toastAction:'',
      toastMessage:'',
      showToast:false,
      editForm: {
        password:'',
        passwordRepeat:''
      },
      passwordError:false,
      title: "Şifre Değiştir",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Şifre Değiştir",
        },
      ],
      editSubmitted: false,
    };
  },
  validations: {
    editForm: {
      password:{required},
      passwordRepeat:{required},
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
  },
  mounted() {

  },
  methods: {
    ...authMethods,
    ...notificationMethods,

    handleSubmit() {
      this.editSubmitted = true;
      this.passwordError=false;
      this.$v.editForm.$touch();

      if (
          this.$v.editForm.$invalid
      ) {
        return;
      } else {
        if(this.editForm.passwordRepeat != this.editForm.password){
          this.passwordError=true;
          return;
        }
        this.changePassword({password:this.editForm.password}).then(()=>{
          this.toastMessage="Şifre başarıyla değiştirildi";
          this.toastAction="success";
          this.showToast=true;
          setTimeout(()=>{
            this.showToast=false;
          },3000)
          this.showModal = false;
          this.editForm.password="";
          this.editForm.passwordRepeat="";
          this.editSubmitted=false;
        })
      }
    },

  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems" />
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row" v-if="true ">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="handleSubmit">
              <div class="row">
                <div class="col-12">
                  <div class="mb-3">
                    <label for="password">Yeni Şifre</label>
                    <input
                        id="password"
                        type="password"
                        v-model="editForm.password"
                        class="form-control"
                        placeholder="Yeni şifrenizi giriniz"
                        :class="{
                    'is-invalid': editSubmitted && ($v.editForm.password.$error || passwordError),
                  }"
                    />
                    <div
                        v-if="editSubmitted && !$v.editForm.password.required"
                        class="invalid-feedback"
                    >
                      Yeni şifre girilmesi gerekli bir alandır.
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="mb-3">
                    <label for="passwordRepeat">Şifre Tekrarı</label>
                    <input
                        id="passwordRepeat"
                        type="password"
                        v-model="editForm.passwordRepeat"
                        class="form-control"
                        placeholder="Şifrenizi tekrar giriniz"
                        :class="{
                    'is-invalid': editSubmitted && ($v.editForm.passwordRepeat.$error || passwordError),
                  }"
                    />
                    <div
                        v-if="editSubmitted && !$v.editForm.passwordRepeat.required"
                        class="invalid-feedback"
                    >
                      Şifre tekrarı girilmesi gerekli bir alandır.
                    </div>
                    <div
                        v-if="editSubmitted && passwordError"
                        class="invalid-feedback"
                    >
                      Şifreler eşleşmelidir.
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-end mt-3">
                <b-button type="submit" variant="success" class="ms-1"
                >Kaydet</b-button
                >
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="spinner-wrapper" v-else>
      <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
    </div>
  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}
.pill span {
  padding: 6px 12px 4px 12px;
}
</style>
